import React, { useEffect, useState } from "react";
import { getAllBiometricCommands, getBiometricCommandCount, rePushCommand } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import { formatDateAndTime, formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import { throttle } from "lodash";
import Toast from "../../../lib/toast";
let timer;

const DeviceLogs = (props) => {

  const [deviceLogs, setDeviceLogs] = useState([]);
  const [isDeviceLogsSpinnerLoader, setDeviceLogsSpinnerLoader] = useState(false);
  var [pageNo,setPageNo] = useState(1);
  const [pageCount,setPageCount] = useState(20);
  const [total,setTotal] = useState(0);
  const [pageSize,setPageSize] = useState(20) 
  const {user,token} = isAuthenticated();
  const [isApiCall,setApiCall] = useState(false);
  const [isButtonLock,setButtonLock] = useState(false);


  const RepushCommand = commandId => async event =>{
    try{
      setButtonLock(true);
      await startLoader();
     
       let response = await rePushCommand(user._id,token,commandId);
       if(response.error){
        new Toast({
          type:'error',
          duration: 2000,
          messsage:response.error
        })
       }else{
         new Toast({
            type:"success",
            duration:1000,
            message:response
          });
          setApiCall(!isApiCall);

       }
    }catch(error){
      
    }
    setButtonLock(false)
    await stopLoader();
  }
  

  const GetParams=()=>{
      let params = {
        pageSize,
        pageNo
      };
      if(localStorage.getItem("branchId")) params.branchIds = localStorage.getItem("branchId");
  
      const queryParams = new URLSearchParams(window.location.search);
      const search_params = Object.fromEntries(queryParams.entries());
  
      if(search_params.search) params.q = search_params.search;
      delete search_params.search;
  
      if(search_params.startDate) search_params.startDate = formatDateTime(search_params.startDate);
      if(search_params.endDate) search_params.endDate = formatDateTime(search_params.endDate);

      if(props.selectedDevice) params.serialNumber = props.selectedDevice.serialNumber;
  
  
      params = {
        ...params,
        ...search_params
      }
  
      return params;
    }
  


  const GetAllBiometricCommands = async (reload) =>{
    try{
      const response = await getAllBiometricCommands(user._id,token,{
         ...GetParams()
      });
      if(!response?.error) setDeviceLogs(reload?response:[...deviceLogs,...response]);
    }catch(error){

    }
  }


  const GetBiometricCommandCount = async () =>{
    try{
      const response = await getBiometricCommandCount(user._id,token,{
          ...GetParams()
      });
      if(!response?.error){
        pageNo=1;
        setPageNo(pageNo)
        setTotal(response.COUNT)
        let PageCount=Math.ceil(response.COUNT / pageSize)
        setPageCount(PageCount)
        props?.handleLogCount(response.COUNT)
      }
    }catch(error){

    }
  }



  const handleScroll = throttle(async (event) => {
      try {
        const { clientHeight, scrollTop, scrollHeight } = event.target;
        if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isDeviceLogsSpinnerLoader) {
            pageNo = pageNo + 1;
            setPageNo(pageNo)
            setDeviceLogsSpinnerLoader(true);
            await GetAllBiometricCommands();
            setDeviceLogsSpinnerLoader(false)
        }
      } catch (error) {
        setDeviceLogsSpinnerLoader(false)
      }
    }, 800);


  useEffect(async () =>{
    if(timer){
      clearInterval(timer)
      timer = undefined;
    }
    if(!timer){
      setDeviceLogsSpinnerLoader(true)
      try{

        await GetAllBiometricCommands(true);
        await GetBiometricCommandCount();

      }catch(error){

      }
      setDeviceLogsSpinnerLoader(false);

      timer = setInterval(()=>{
        GetAllBiometricCommands(true);
        GetBiometricCommandCount();
      },1000*30);
    }
  },[window.location.search,window.localStorage.getItem("branchId"),props.selectedDevice,isApiCall]);



  return(
    <div className="scrollable-body" style={{zIndex:0}}>
      <div className="flex-item scrollable-table-xy" onScroll={handleScroll}>
        <div className="scrollable-table-header" style={{zIndex:4}}>
          <div className="fixed-container d-flex">
            <div className="header-middle-container d-flex">
              <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">Creation Date</p>
              </div>
              <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">SerialNumber</p>
              </div>
              <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">Vendor</p>
              </div>
              <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">Command</p>
              </div>
              {/* <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">Status</p>
              </div> */}
              {/* <div className="item-container item-container-5 d-flex">
                <p className="flex-item d-flex color-white">Execution Date</p>
              </div> */}
            </div>
            {/* <div className="action-container d-flex">
              <p className="flex-item color-white fs-16 color-white margin-auto">Action</p>
            </div> */}
          </div>
        </div>
        {
          deviceLogs.map((log, index) => {
            return(
              <div className="scrollable-table-body">
                <div className="scrollable-table-body-middle-container d-flex" style={{borderBottom:"1px solid #dadada", paddingRight:"20px"}}>
                  <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex">{log.createdAt ? formatDateAndTime(new Date(log.createdAt)) : '-'}</p>
                  </div>
                  <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex">{log?.deviceDetails?.serialNumber}</p>
                  </div>
                     <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex" style={{textTransform:'capitalize'}}>{log?.deviceDetails?.vendor}</p>
                  </div>
                  <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex">{log?.message}</p>
                  </div>
                  {/* <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex">{log?.status}</p>
                  </div>
                  <div className="item-container item-container-5 d-flex">
                    <p className="flex-item d-flex">{log.updatedAt ? formatDateAndTime(new Date(log.updatedAt)) : '-'}</p>
                  </div> */}
                </div>
                {false && <div className="action-container action-container-body d-flex" style={{borderBottom:"1px solid #C3C3C3"}}>
                  {/* <svg className="flex-item margin-auto cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.616 20C7.168 20 6.78667 19.8427 6.472 19.528C6.15733 19.2133 6 18.8323 6 18.385V6H5V5H9V4.23H15V5H19V6H18V18.385C18 18.845 17.846 19.2293 17.538 19.538C17.23 19.8467 16.8453 20.0007 16.384 20H7.616ZM17 6H7V18.385C7 18.5643 7.05767 18.7117 7.173 18.827C7.28833 18.9423 7.436 19 7.616 19H16.385C16.5383 19 16.6793 18.936 16.808 18.808C16.9367 18.68 17.0007 18.5387 17 18.384V6ZM9.808 17H10.808V8H9.808V17ZM13.192 17H14.192V8H13.192V17Z" fill="#CC0000"/>
                  </svg> */}
                 {(log?.status != "Success" && !log?.isRepushed)&& <svg onClick={isButtonLock?null:RepushCommand(log._id)} className="flex-item margin-auto cursor-pointer" width="24" height="24" viewBox="0 0 61 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M26.5169 10.0545C29.1218 9.69894 31.7617 9.72021 34.3567 10.117L35.47 10.3084L35.7591 10.3982C36.4031 10.6666 36.7926 11.3587 36.6536 12.0701C36.514 12.7805 35.8935 13.2746 35.1966 13.281L34.8919 13.2537L33.9036 13.0818C31.5872 12.7276 29.2286 12.7081 26.9036 13.0271L26.8841 13.031C21.6818 13.6737 16.7755 15.8043 12.7552 19.1677C8.73469 22.5314 5.77082 26.9846 4.22 31.992C2.66935 36.9991 2.59753 42.3472 4.01297 47.3943C5.42866 52.4417 8.27165 56.9745 12.2005 60.4451C16.1292 63.9155 20.9781 66.1786 26.1614 66.9607C31.3438 67.7424 36.6422 67.0112 41.4192 64.8552C46.1972 62.6984 50.253 59.2055 53.095 54.8006C55.759 50.6711 57.2504 45.9026 57.4231 41.0037L57.4427 40.0232C57.4426 39.995 57.4411 39.9655 57.4427 39.9373C57.4793 39.2874 57.4793 38.634 57.4427 37.9841L58.9427 37.9021L60.4387 37.8162C60.4801 38.5499 60.4809 39.2854 60.4427 40.0193L60.4231 41.1091C60.2314 46.548 58.5721 51.841 55.6145 56.4256C52.4593 61.316 47.9581 65.1951 42.6536 67.5896C37.3495 69.9836 31.4664 70.7938 25.7122 69.9256C19.9574 69.0572 14.574 66.5443 10.2122 62.6912C5.85159 58.8385 2.69393 53.8094 1.12235 48.2068C-0.44921 42.6036 -0.368492 36.6642 1.35281 31.1052C3.0745 25.5462 6.36607 20.6013 10.8294 16.867C15.2931 13.1326 20.7409 10.7639 26.5169 10.0506V10.0545ZM58.8567 36.4021C59.6838 36.3555 60.392 36.9891 60.4387 37.8162L57.4427 37.9841C57.3966 37.1575 58.03 36.4488 58.8567 36.4021Z" fill="black"/>
                    <path d="M26.1766 0.464932C26.6764 -0.0589254 27.4646 -0.14261 28.0555 0.22665L28.2977 0.41415L39.497 11.0938C39.8248 11.4065 39.995 11.8532 39.9579 12.3048C39.9297 12.6434 39.7868 12.9592 39.5595 13.2032L39.3055 13.4181L26.1454 22.379L25.8798 22.5235C25.2361 22.7933 24.4717 22.5834 24.0634 21.9845C23.5971 21.2997 23.7731 20.3648 24.4579 19.8985L36.0829 11.9845L26.2274 2.58603L26.0282 2.35556C25.6299 1.78262 25.6764 0.989578 26.1766 0.464932Z" fill="black"/>
                  </svg>}


                </div>}
              </div>
            )
          })
        }
        {isDeviceLogsSpinnerLoader && <div className="loader-5 center"><span></span></div>}
      </div>
    </div>
  )
}

export default DeviceLogs;